import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { VIDEOS } from '../mock/mock';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();
  const videoRef = useRef(null);
  const [currentVideo, setCurrentVideo] = useState(0);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const handleEnd = () => setCurrentVideo(prev => (prev + 1) % VIDEOS.length);
    v.addEventListener('ended', handleEnd);
    v.load();
    v.play().catch(() => {});
    return () => v.removeEventListener('ended', handleEnd);
  }, [currentVideo]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        key={currentVideo}
      >
        <source src={VIDEOS[currentVideo]} type="video/mp4" />
      </video>
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 h-full flex items-center justify-center px-6">
        <div className="max-w-4xl text-center fade-in">
          <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94B]/50 bg-black/20 backdrop-blur-sm mb-6">
            <span className="text-[#D4A94B] text-xs md:text-sm tracking-[0.25em] uppercase font-medium">
              {t.hero.badge}
            </span>
          </div>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-semibold text-white leading-[1.05] mb-6">
            {t.hero.title}
          </h1>
          <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-10 font-light">
            {t.hero.subtitle}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollTo('lunch')}
              className="bg-[#B8934A] hover:bg-[#A7823C] text-white px-8 py-3.5 rounded-full font-medium tracking-wide transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              {t.hero.ctaLunch}
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/80 text-white hover:bg-white hover:text-[#1F2A24] px-8 py-3.5 rounded-full font-medium tracking-wide transition-all"
            >
              {t.hero.ctaContact}
            </button>
          </div>
        </div>
      </div>

      <button
        onClick={() => scrollTo('info')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 hover:text-white transition-colors animate-bounce"
        aria-label="scroll"
      >
        <ChevronDown size={32} />
      </button>

      <div className="absolute bottom-8 right-8 z-10 flex gap-2">
        {VIDEOS.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentVideo(idx)}
            className={`h-1.5 rounded-full transition-all ${idx === currentVideo ? 'w-8 bg-[#D4A94B]' : 'w-4 bg-white/40 hover:bg-white/70'}`}
            aria-label={`video ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
